export const VERY_IDLE_API_KEY_DAYS = 100;

export function isVeryIdleAPIKey(apiKey, now = new Date()) {
  const updatedAtValue = apiKey?.attributes?.updated_at;
  if (!updatedAtValue) {
    return false;
  }

  const updatedAt = new Date(updatedAtValue);
  if (Number.isNaN(updatedAt.getTime())) {
    return false;
  }

  if (updatedAt > now) {
    return false;
  }

  return (now - updatedAt) / (1000 * 60 * 60 * 24) > VERY_IDLE_API_KEY_DAYS;
}
